export default __webpack_public_path__ + "static/media/Punto_12_Cantina_Palio_Marinaro_ITA_Def.947a54a8.aac";